import { render, staticRenderFns } from "./CwpeBulkParsePanel.vue?vue&type=template&id=2c36d914&"
import script from "./CwpeBulkParsePanel.vue?vue&type=script&lang=js&"
export * from "./CwpeBulkParsePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports